// @ts-nocheck
import { makeStyles } from '@material-ui/core';

import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import { grey } from 'assets/colors/colors';

export const labelColorStyle = {
  color: 'rgba(95, 109, 131, 1)',
  marginBottom: '4px',
};
export const borderRight = {
  borderRight: '1px solid rgba(224, 224, 224, 1)',
};
export const useAttachmentStyles = makeStyles({
  attachmentContainer: {
    border: '1px dashed #98A5B9',
    width: '300px',
    backgroundColor: '#EAEDF1',
    height: '48px',
    borderRadius: '4px',
  },
  attachmentContainerText: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    cursor: 'pointer',
  },

  dropFileText: {
    fontFamily: '"Roboto", sans serif',
    fontWeight: 400,
    fontSize: '14px',
    color: '#6A737B',
  },
  multiAttachmentContainer: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  progress: {
    marginRight: '10px',
    alignSelf: 'center',
  },
  fileInput: {
    display: 'none',
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
  },
  addIcon: {
    fontSize: '18px !important',
  },
});

export const LightTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: 'white',
    color: '#000',
    boxShadow: theme.shadows[1],
    fontSize: 12,
    cursor: 'pointer',
  },
}))(Tooltip);

export const customScrollbar = {
  '&::-webkit-scrollbar': {
    height: '12px',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: 'rgba(211, 215, 221, 1)',
    borderRadius: '8px',
    '&:hover': {
      backgroundColor: grey.g500,
    },
  },
  paddingBottom: '8px',
};

export const placeholderStyle = {
  '& input::placeholder': {
    textTransform: 'none !important',
  },
};
